<app-header></app-header>
<ion-content [scrollY]="false" *ngIf="vm$ | async; let vm">
  <cdk-virtual-scroll-viewport
    #mainVirtualScroll
    appCustomVs
    [indexOffset]="vm.scrollItemHeights.offset"
    [itemHeights]="vm.scrollItemHeights.heights"
    (scrolledIndexChange)="scrolledIndexChange($event, vm.pageNum, vm.hasNextPage, vm.isLoadingTransaction)"
    [bufferBefore]="vsRowBuffer"
    [bufferAfter]="vsRowBuffer"
  >
    <div class="invoices-content gray-content-bg" #mainDivScroll>
      <div class="all-invoices-header">
        <app-header-filters
          [isTouch]="(isTouch$ | async)"
          [breadcrumbs]="vm.breadcrumbs"
          [service]="allInvoicesService"
          [filters]="invoiceFilters"
          [showQuickDateFilterOption]="true"
          [showResetFilterOption]="true"
          [isLoading]="isInitialLoading"
          [platformType]="platformService?.platformType"
          [filterVm$]="vm$"
          [title]="title"
          [isWindows]="platformService?.isWindows()"
          [quickFilters]="quickFilters"
          [defaultFilterId]="InvoiceFilterIds.TransactionNumber"
          [defaultDateFilterId]="InvoiceFilterIds.IssueDate"
          [showShare]="!vm.isLoadingTransaction && vm.transactions.length > 0 && showShareAndDownload"
          [showISRFilter]="true"
          [showOrderNumberFilter]="showOrderNumber"
          (downloadAllEmitter)="downloadAllInvoicesPage()"
          (printAllEmitter)="printAllInvoices()"
          (resetFiltersEmitter)="resetFilters()"
          (toggleStatusEmitter)="allInvoicesService.setFilter($event)"
          (shareEmitter)="shareAllInvoices()"
          (shareDownloadEmitter)="openShareDownload(vm.transactions)"
        ></app-header-filters>
      </div>

      <div class="all-invoices-content margin">
        <ion-grid>
          <ng-container *ngIf="!isInitialLoading">
            <div data-cy="table-top-buttons-section" class="make-a-payment">
              <ng-container
                *ngTemplateOutlet="goToMakeAPaymentButton; context: { vm: vm }"
              ></ng-container>
              <ion-button
                *ngIf="showViewStatementsBtn"
                data-cy="view-statements-button"
                class="usf-outline-green-button"
                (click)="goToARStatementsWithCustomers()"
              >
                {{ 'i18n.payments.allInvoices.accessButtons.statements' |
                translate }}
              </ion-button>
            </div>
            <app-table-header
              *ngIf="platformService?.platformType === PlatformEnum.desktop && vm.transactions.length > 0"
              [dataColumns]="[
            {
              size: this.columnSizes[ColumnNames.Checkbox],
              dataCyName: 'checkbox',
              isCheckbox: true
            },
            {
              size: this.columnSizes[ColumnNames.CustomerInformation],
              dataCyName: 'customer',
              sortField: SortFields.customerName,
              sortDirectionByDefault: SortDirection.ASC,
              label: (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
                'i18n.payments.recentInvoicesCredits.customerCut' :
                'i18n.payments.recentInvoicesCredits.customer') | translate
            },
            {
              size: this.columnSizes[ColumnNames.TransactionInformation],
              dataCyName: 'transaction',
              sortField: SortFields.transaction,
              label: (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
                'i18n.payments.recentInvoicesCredits.transactionCut'
                : 'i18n.payments.recentInvoicesCredits.transaction') | translate
            },
            {
              size: this.columnSizes[ColumnNames.PoNumber],
              dataCyName: 'cust-po',
              sortField: SortFields.customerPO,
              label:  ('i18n.payments.recentInvoicesCredits.custPo' | translate)
            },
            {
              size: this.columnSizes[ColumnNames.OrderNumber],
              dataCyName: 'order-number',
              sortField: SortFields.orderNumber,
              label:  ('i18n.payments.recentInvoicesCredits.orderNumber' | translate)
            },
            {
              size: this.columnSizes[ColumnNames.IssueDate],
              dataCyName: 'issue-date',
              sortField: SortFields.issueDate,
              label:  (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
                'i18n.payments.recentInvoicesCredits.issueDateCut' :
                'i18n.payments.recentInvoicesCredits.issueDate') | translate
            },
            {
              size: this.columnSizes[ColumnNames.Amount],
              dataCyName: 'amount',
              sortField: SortFields.amount,
              label:  (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
                'i18n.payments.recentInvoicesCredits.amountCut'  :
                'i18n.payments.recentInvoicesCredits.amount') | translate
            },
            {
              size: this.columnSizes[ColumnNames.AmountDue],
              dataCyName: 'amount-due',
              sortField: SortFields.amountdue,
              label:  (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
                'i18n.payments.recentInvoicesCredits.amountDueCut'  :
                'i18n.payments.recentInvoicesCredits.amountDue') | translate
            },
            {
              size: this.columnSizes[ColumnNames.DueDate],
              dataCyName: 'due-date',
              sortField: SortFields.dueDate,
              label:  'i18n.payments.recentInvoicesCredits.dueDate' | translate
            },
            {
              size: this.columnSizes[ColumnNames.Status],
              dataCyName: 'status',
              sortField: SortFields.status,
              label:  (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
                'i18n.payments.recentInvoicesCredits.statusCut'  :
              'i18n.payments.recentInvoicesCredits.status') | translate
            },
            {
              size: 'auto',
              dataCyName: 'blank',
              label:  '',
              isNotSortable: true
            },
          ]"
              [sortField]="sortField"
              [sortDirection]="sortDirection"
              [isSelectable]="vm.isSelectable"
              (clickEmit)="handleSort($event)"
            ></app-table-header>
            <ng-container
              *ngIf="!vm.isLoadingTransaction && !vm.transactions.length"
              [class]="showViewStatementsBtn ? 'no-info-message top-buttons-visible':'no-info-message' "
            >
              <ion-row>
                <ion-col>
                  <app-empty-states
                    [title]="'i18n.payments.makePayment.thereAreNoInvoices' | translate"
                  >
                  </app-empty-states>
                </ion-col>
              </ion-row>
            </ng-container>
          </ng-container>

          <ng-container
            *cdkVirtualFor="
            let transaction of vm.transactions;
            let i = index;
            trackBy: trackByIdx
          "
          >
            <ng-container
              *ngIf="platformService?.platformType === PlatformEnum.desktop;"
            >
              <app-transaction-row-desktop
                [vm]="transaction"
                [browserDimensions]="browserDimensions"
                [isTouch]="(isTouch$ | async)"
                [selectable]="vm.isSelectable"
                [translatorText]="transactionRowText"
                [showFullPO]="showFullPO"
                [showOrderNumber]="showOrderNumber"
                [columnSizes]="columnSizes"
                (poClickEmitter)="poNumberClicked()"
                (transactionRowClickEmitter)="selectTransactionRow($event)"
                (moreOptionsClickEmitter)="openMoreOptions($event)"
                (viewInvoiceClickEmitter)="viewInvoice($event)"
              ></app-transaction-row-desktop>
            </ng-container>

            <ng-container
              *ngIf="platformService?.platformType !== PlatformEnum.desktop;"
            >
              <app-transaction-row-touch
                [vm]="transaction"
                [selectable]="vm.isSelectable"
                [showOrderNumber]="showOrderNumber"
                [translatorText]="transactionRowText"
                [isMobile]="isMobile"
                (transactionRowClickEmitter)="selectTransactionRow($event)"
                (moreOptionsClickEmitter)="openMoreOptions($event)"
                (viewInvoiceClickEmitter)="viewInvoice($event)"
              ></app-transaction-row-touch>
            </ng-container>
          </ng-container>
          <div
            class="initial-loading"
            *ngIf="isInitialLoading || (vm.isLoadingTransaction && vm.pageNum > 0)"
          >
            <ion-skeleton-text
              class="item"
              animated
              *ngFor="let i of [].constructor(7)"
            ></ion-skeleton-text>
          </div>
        </ion-grid>
      </div>
      <app-footer></app-footer>
    </div>
  </cdk-virtual-scroll-viewport>
</ion-content>

<ng-template #goToMakeAPaymentButton let-vm="vm">
  <ion-button
    *ngIf="vm.payCCAisOn"
    data-cy="go-to-make-a-payment-button"
    class="usf-outline-green-button"
    (click)="goToMakeAPayment()"
  >
    {{ 'i18n.payments.allInvoices.accessButtons.makePayment' | translate }}
  </ion-button>
</ng-template>

<div
  class="top-button-action"
  *ngIf="vm$ | async; let vm"
  [class.pay-footer-hidden]="vm.selectedTransactions.length < 1"
>
  <ng-container
    *ngTemplateOutlet="goToMakeAPaymentButton; context: { vm: vm }"
  ></ng-container>

  <app-top-button
    [mainVirtualScroll]="mainVirtualScroll"
    [isMobile]="platformService?.platformType === platformService?.platformEnum.mobile"
  ></app-top-button>
</div>

<app-selection-banner
  *ngIf="vm$ | async; let vm"
  [class.ion-hide]="vm.selectedTransactions.length < 1"
  [countItemsSelected]="vm.selectedTransactions.length"
  [isDownloadEnabled]="invoiceIsrService.hasSomeISR(vm.selectedTransactions)"
  slot="fixed"
  (deselectAllClickEmitter)="clearAllSelections()"
  (selectAllClickEmitter)="selectAllInvoices()"
  (downloadClickEmitter)="downloadSelectedInvoices(vm.selectedTransactions)"
></app-selection-banner>
